// extracted by mini-css-extract-plugin
module.exports = {"Modal":"_3uROSx4tMeUquU-g-6N4CH"};